/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdTags200,
  GetApiV1PersonIdTags401,
  GetApiV1PersonIdTags404,
  GetApiV1PersonIdTags500,
  GetApiV1PersonIdTagsPathParams,
  GetApiV1PersonIdTagsQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdTags.ts";
import { personTagsViewModelSchema } from "../personTagsViewModelSchema.ts";

export const getApiV1PersonIdTagsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdTagsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdTags200Schema = z.lazy(
  () => personTagsViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdTags200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdTags401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTags401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdTags404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTags404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdTags500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTags500>;

export const getApiV1PersonIdTagsQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdTags200Schema,
) as unknown as ToZod<GetApiV1PersonIdTagsQueryResponse>;
